export default __webpack_public_path__ + "static/media/send-icon.28c70ce2.svg";